module.exports = __webpack_public_path__ + "static/media/file-signature.14ad5c11.svg";